import { render } from "./CustomerDueReport.vue?vue&type=template&id=b5565834&scoped=true"
import script from "./CustomerDueReport.vue?vue&type=script&lang=js"
export * from "./CustomerDueReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=b5565834&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5565834"]])

export default __exports__